<div class="popup-container">
  <div class="popup-content">
    <div class="popup-header">
      <span class="popup-title">Select Report Type</span>
      <mat-icon (click)="closeModal()" class="close-button">close</mat-icon>

    </div>

    <form [formGroup]="reportTypeForm" (ngSubmit)="onSubmit()">
      <div class="radio-group">
        <label class="radio-item">
          <input type="radio" formControlName="reportType" value="speedConsumption" />
          Speed and Consumption Report
        </label>

        <label class="radio-item">
          <input type="radio" formControlName="reportType" value="portConsumption" />
          Port Consumption Report
        </label>

        <label class="radio-item">
          <input type="radio" formControlName="reportType" value="combinedReport" />
          Combined Report
        </label>
      </div>

      <button type="submit" [disabled]="reportTypeForm.invalid || isLoading">
        {{ isLoading ? 'Loading...' : 'Submit' }}
      </button>
    </form>
  </div>
</div>